module.exports = __webpack_public_path__ + "img/alipay.6e7f7012.png";